export default __webpack_public_path__ + "static/media/les_andelys10.be287572.jpg";